/* Escala beneficios v2 2026-09-18: envío 1999.01 / 3% 2200.01 / 5% 3100.01 */
(function(){
  'use strict';
  var bar=document.getElementById('dfBenefitsProgressGlobal');
  if(!bar)return;

  var isWholesale=bar.getAttribute('data-wholesale')==='true';
  var isProductPage=!!document.querySelector('[data-ProductSection]')||(document.body&&document.body.className.indexOf('template-product')>-1);
  var message=bar.querySelector('[data-dfbp-message]');
  var subtotal=bar.querySelector('[data-dfbp-subtotal]');
  var fill=bar.querySelector('[data-dfbp-fill]');
  var marks=[].slice.call(bar.querySelectorAll('[data-dfbp-threshold]'));
  var compactToggle=null;
  var compactSubtotal=null;
  var compactArrow=null;
  var nf=new Intl.NumberFormat('es-MX',{minimumFractionDigits:2,maximumFractionDigits:2});
  var nfGoal=new Intl.NumberFormat('es-MX',{minimumFractionDigits:0,maximumFractionDigits:0});
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var lastCartCount=null;
  var timer=null;
  var refreshTimers=[];
  var cartReadVersion=0;
  var SHIP=199901;
  var D1=220001;
  var tiers=[
    {min:D1,pct:3},
    {min:310001,pct:5},
    {min:1600001,pct:10},
    {min:2400001,pct:13},
    {min:3200001,pct:16},
    {min:4000001,pct:18},
    {min:4800001,pct:20}
  ];

  var baseCartGross=0;
  var baseCartShip=0;
  var productForm=isProductPage?document.querySelector('[data-AddToCartForm]'):null;
  var productQty=productForm?productForm.querySelector('[data-Quantity]'):null;
  var productAdd=productForm?productForm.querySelector('[data-AddToCart]'):null;
  var productData=null;

  if(isProductPage){
    var productJson=document.querySelector('script[id^="ProductJson-"]');
    if(productJson){
      try{productData=JSON.parse(productJson.textContent||'{}');}catch(e){productData=null;}
    }
  }

  function money(cents){return 'MXN '+nf.format((Number(cents)||0)/100);}
  function goalLeft(target,current){
    target=Number(target)||0;
    current=Number(current)||0;
    var visibleTarget=target%100===1?target-1:target;
    var diff=visibleTarget-current;
    if(diff<=0)return 'menos de MXN 1';
    return 'MXN '+nfGoal.format(Math.ceil(diff/100));
  }

  function tier(cents){
    cents=Number(cents)||0;
    for(var i=tiers.length-1;i>=0;i--){if(cents>=tiers[i].min)return tiers[i].pct;}
    return 0;
  }

  function estimatedAfterDiscount(cents){
    var p=tier(cents);
    return Math.round(cents*(100-p)/100);
  }

  function originalSubtotal(cart){
    if(cart&&typeof cart.original_total_price==='number')return cart.original_total_price;
    if(cart&&cart.items&&cart.items.length){
      return cart.items.reduce(function(sum,item){return sum+(Number(item.original_line_price)||0);},0);
    }
    return 0;
  }

  function shippingSubtotal(cart,original){
    if(cart&&typeof cart.total_price==='number')return cart.total_price;
    if(cart&&typeof cart.total_discount==='number')return Math.max(0,original-cart.total_discount);
    return original;
  }

  function interpolate(cents,points){
    var i,a,b;
    if(cents<=points[0][0])return points[0][1];
    if(cents>=points[points.length-1][0])return points[points.length-1][1];
    for(i=1;i<points.length;i++){
      if(cents<=points[i][0]){
        a=points[i-1];b=points[i];
        return a[1]+(cents-a[0])/(b[0]-a[0])*(b[1]-a[1]);
      }
    }
    return 100;
  }

  function progress(original,shipBase){
    original=Number(original)||0;
    shipBase=Number(shipBase)||0;
    var discountProgress=interpolate(original,[[0,0],[SHIP,9],[D1,17],[310001,25],[1600001,42],[2400001,57],[3200001,72],[4000001,86],[4800001,100]]);
    var shippingProgress=Math.max(0,Math.min(9,(shipBase/SHIP)*9));
    return original<D1&&shipBase<SHIP?Math.min(discountProgress,shippingProgress):Math.max(shippingProgress,discountProgress);
  }

  function copy(original,shipBase){
    original=Number(original)||0;
    shipBase=Number(shipBase)||0;
    var shippingReached=shipBase>=SHIP;
    var currentPct=tier(original);
    var nextTier=null;
    for(var i=0;i<tiers.length;i++){
      if(original<tiers[i].min){nextTier=tiers[i];break;}
    }

    if(!shippingReached){
      var shippingGap=goalLeft(SHIP,shipBase);
      if(currentPct>0)return '✓ '+currentPct+'%. Te faltan '+shippingGap+' para obtener envío gratis.';
      return 'Te faltan '+shippingGap+' para obtener envío gratis.';
    }
    if(currentPct===0)return '✓ Envío gratis. Te faltan '+goalLeft(D1,original)+' para llegar al 3%.';
    if(!nextTier)return '🏆 Máximo beneficio: envío gratis + '+currentPct+'%.';
    return '✓ Envío gratis + '+currentPct+'%. Te faltan '+goalLeft(nextTier.min,original)+' para llegar al '+nextTier.pct+'%.';
  }

  function setVisible(show){
    bar.hidden=!show;
    document.body.classList.toggle('dfbp-active',!!show);
    document.body.classList.toggle('dfbp-wholesale',isWholesale);
  }

  function render(original,shipBase,show){
    original=Math.max(0,Number(original)||0);
    shipBase=Math.max(0,Number(shipBase)||0);
    setVisible(show);
    if(!show)return;
    subtotal.textContent=money(original);
    if(compactSubtotal)compactSubtotal.textContent=money(original);
    message.textContent=copy(original,shipBase);
    fill.style.width=Math.min(100,progress(original,shipBase))+'%';
    marks.forEach(function(mark){
      var threshold=Number(mark.getAttribute('data-dfbp-threshold')||0);
      var reached=threshold===SHIP?shipBase>=threshold:original>=threshold;
      mark.classList.toggle('is-on',reached);
    });
    syncCompactBarOffset();
  }

  function syncCompactBarOffset(){
    if(!isProductPage||!bar.classList.contains('dfbp-product-compact'))return;
    var height=Math.ceil(bar.getBoundingClientRect().height||0);
    if(height>0)document.body.style.setProperty('--dfbp-mobile-bar-offset',(height+8)+'px');
  }

  function setCompactExpanded(expanded){
    if(!compactToggle)return;
    bar.classList.toggle('is-expanded',!!expanded);
    bar.classList.toggle('is-collapsed',!expanded);
    compactToggle.setAttribute('aria-expanded',expanded?'true':'false');
    compactToggle.setAttribute('aria-label',expanded?'Ocultar detalle de beneficios':'Ver detalle de beneficios');
    if(compactArrow)compactArrow.textContent=expanded?'▾':'▴';
    if(window.requestAnimationFrame)window.requestAnimationFrame(syncCompactBarOffset);
    else setTimeout(syncCompactBarOffset,0);
  }

  function setupProductCompactBar(){
    if(!isProductPage)return;
    var inner=bar.querySelector('.dfbp-global__inner');
    if(!inner)return;
    if(!inner.id)inner.id='dfBenefitsProgressDetails';

    compactToggle=document.createElement('button');
    compactToggle.type='button';
    compactToggle.className='dfbp-global__toggle';
    compactToggle.setAttribute('aria-controls',inner.id);

    var label=document.createElement('span');
    label.className='dfbp-global__toggle-label';
    label.textContent='🎁 Beneficios';

    compactSubtotal=document.createElement('strong');
    compactSubtotal.className='dfbp-global__toggle-subtotal';
    compactSubtotal.textContent='MXN 0.00';

    compactArrow=document.createElement('span');
    compactArrow.className='dfbp-global__toggle-arrow';
    compactArrow.setAttribute('aria-hidden','true');

    compactToggle.appendChild(label);
    compactToggle.appendChild(compactSubtotal);
    compactToggle.appendChild(compactArrow);
    bar.insertBefore(compactToggle,inner);
    bar.classList.add('dfbp-product-compact');
    document.body.classList.add('dfbp-product-compact-body');
    setCompactExpanded(false);

    compactToggle.addEventListener('click',function(){
      setCompactExpanded(!bar.classList.contains('is-expanded'));
    });
    window.addEventListener('resize',syncCompactBarOffset);
  }

  function productQuantity(){
    if(!productQty)return 0;
    var q=parseInt(productQty.value,10);
    return isNaN(q)||q<0?0:q;
  }

  function selectedVariantPrice(){
    if(!isProductPage)return 0;
    var idField=productForm?productForm.querySelector('select[name="id"], input[name="id"]'):null;
    var variantId=idField?String(idField.value||''):'';
    if(productData&&productData.variants&&productData.variants.length){
      for(var i=0;i<productData.variants.length;i++){
        if(String(productData.variants[i].id)===variantId){
          return Math.max(0,Number(productData.variants[i].price)||0);
        }
      }
    }
    var priceEl=document.querySelector('[data-ProductPrice]');
    if(priceEl){
      var raw=String(priceEl.textContent||'').replace(/[^0-9.,-]/g,'').replace(/,/g,'');
      var val=parseFloat(raw);
      if(!isNaN(val))return Math.max(0,Math.round(val*100));
    }
    return 0;
  }

  function syncProductAddButton(){
    if(!productAdd)return;
    var q=productQuantity();
    if(q<=0){
      if(!productAdd.disabled)productAdd.setAttribute('data-dfbp-zero-lock','1');
      productAdd.disabled=true;
    }else if(productAdd.getAttribute('data-dfbp-zero-lock')==='1'){
      productAdd.removeAttribute('data-dfbp-zero-lock');
      if(!productAdd.classList.contains('disabled'))productAdd.disabled=false;
    }
  }

  function renderProductPreview(){
    if(!isProductPage)return;
    var pending=selectedVariantPrice()*productQuantity();
    var previewGross=Math.max(0,baseCartGross+pending);
    var otherDiscounts=Math.abs(baseCartShip-estimatedAfterDiscount(baseCartGross))>2;
    var previewShip=pending>0?(otherDiscounts?baseCartShip:estimatedAfterDiscount(previewGross)):baseCartShip;
    render(previewGross,previewShip,true);
    if(pending>0){
      message.textContent=otherDiscounts?'El envío y los descuentos de tu selección se confirman al agregar al carrito. Se conservan los descuentos del carrito actual.':'Estimado al agregar: '+copy(previewGross,previewShip);
    }
    syncDiscountBadge();
    syncProductAddButton();
  }

  function resetProductSelectionAfterAdd(){
    if(!isProductPage||!productQty)return;
    productQty.value='0';
    renderProductPreview();
    setTimeout(syncProductAddButton,0);
    setTimeout(syncProductAddButton,600);
  }

  function refreshCart(){
    setupProductCompactBar();

  if(isWholesale&&typeof window.DestinWholesaleSubtotal==='number'){
      var wholesaleGross=Math.max(0,Number(window.DestinWholesaleSubtotal)||0);
      render(wholesaleGross,estimatedAfterDiscount(wholesaleGross),true);
      return Promise.resolve();
    }
    var readVersion=++cartReadVersion;
    return window.fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}})
      .then(function(res){if(!res.ok)throw new Error('cart');return res.json();})
      .then(function(cart){
        if(readVersion!==cartReadVersion)return;
        acceptCart(cart);
      })
      .catch(function(){
        if(isWholesale){
          var wholesaleGross=Math.max(0,Number(window.DestinWholesaleSubtotal)||0);
          render(wholesaleGross,estimatedAfterDiscount(wholesaleGross),true);
        }else if(isProductPage){
          renderProductPreview();
        }
      });
  }

  function acceptCart(cart){
    lastCartCount=Number(cart.item_count)||0;
    var gross=originalSubtotal(cart);
    var shipBase=shippingSubtotal(cart,gross);
    if(isProductPage){
      baseCartGross=gross;
      baseCartShip=shipBase;
      renderProductPreview();
    }else{
      render(gross,shipBase,isWholesale||lastCartCount>0);
    }
  }

  function clearRefreshTimers(){
    refreshTimers.forEach(clearTimeout);
    refreshTimers=[];
  }

  function scheduleRefresh(){
    clearRefreshTimers();
    cartReadVersion++;
    refreshTimers=[120,450,1000,2200].map(function(delay){return setTimeout(refreshCart,delay);});
  }

  document.addEventListener('df:cart:confirmed',function(event){
    if(!event.detail||!event.detail.cart)return;
    clearRefreshTimers();
    cartReadVersion++;
    acceptCart(event.detail.cart);
  });

  function syncDiscountBadge(){
    if(!productForm||!productData||!productData.variants)return;
    var idField=productForm.querySelector('select[name="id"], input[name="id"]');
    var variantId=idField?String(idField.value):'';
    var variant=productData.variants.find(function(v){return String(v.id)===variantId;});
    var scope=productForm.closest('[data-ProductSection]')||document;
    var badge=scope.querySelector('[data-df-discount-badge]');
    if(!badge)return;
    var sale=variant&&Number(variant.compare_at_price)>Number(variant.price);
    badge.style.display=sale?'inline-block':'none';
    if(sale)badge.querySelector('[data-df-discount-percent]').textContent=String(Math.round((variant.compare_at_price-variant.price)*100/variant.compare_at_price));
  }

  if(isProductPage&&productQty){
    productQty.value='0';
    productQty.setAttribute('min','0');
    syncProductAddButton();

    document.addEventListener('click',function(event){
      var btn=event.target&&event.target.closest?event.target.closest('.quantity-select .adjust-minus, .quantity-select .adjust-plus'):null;
      if(!btn||!productForm||!productForm.contains(btn))return;
      event.preventDefault();
      event.stopPropagation();
      if(event.stopImmediatePropagation)event.stopImmediatePropagation();

      var q=productQuantity();
      if(btn.classList.contains('adjust-plus'))q+=1;
      else q=Math.max(0,q-1);
      productQty.value=String(q);
      renderProductPreview();
    },true);

    productQty.addEventListener('input',function(){
      var q=productQuantity();
      productQty.value=String(q);
      renderProductPreview();
    });

    productQty.addEventListener('change',function(){
      var q=productQuantity();
      productQty.value=String(q);
      renderProductPreview();
    });

    document.addEventListener('change',function(event){
      var target=event.target;
      if(!target||!productForm||!productForm.contains(target))return;
      if(target.matches('select[name="id"], .single-option-selector, input[type="radio"]')){
        setTimeout(renderProductPreview,0);
        setTimeout(renderProductPreview,100);
      }
    },true);

    var visiblePrice=document.querySelector('[data-ProductPrice]');
    if(visiblePrice&&window.MutationObserver){
      new MutationObserver(function(){setTimeout(renderProductPreview,0);}).observe(visiblePrice,{childList:true,characterData:true,subtree:true});
    }

    document.addEventListener('submit',function(event){
      var form=event.target;
      if(!form||!productForm)return;
      if(form===productForm.querySelector('form')||productForm.contains(form)){
        if(productQuantity()<=0){
          event.preventDefault();
          event.stopPropagation();
          if(event.stopImmediatePropagation)event.stopImmediatePropagation();
        }
      }
    },true);
  }

  document.addEventListener('df:benefits:update',function(event){
    if(!event.detail)return;
    if(event.detail.source==='wholesale'){
      window.DestinWholesaleSubtotal=Number(event.detail.subtotal)||0;
      var wholesaleGross=Math.max(0,window.DestinWholesaleSubtotal);
      render(wholesaleGross,estimatedAfterDiscount(wholesaleGross),true);
    }
  });

  document.addEventListener('submit',function(event){
    var form=event.target;
    if(form&&form.matches&&((form.action||'').indexOf('/cart/add')>-1||form.hasAttribute('data-AddToCartForm')))scheduleRefresh();
  },true);

  document.addEventListener('click',function(event){
    var el=event.target&&event.target.closest?event.target.closest('[data-AddToCart], .add-to-cart, [name="add"], button[type="submit"]'):null;
    if(el)scheduleRefresh();
  },true);

  ['cart:updated','cart:refresh','cart:change','product:added','ajaxProduct:added'].forEach(function(name){
    document.addEventListener(name,scheduleRefresh);
  });

  if(window.fetch){
    var nativeFetch=window.fetch;
    window.fetch=function(){
      var args=arguments;
      return nativeFetch.apply(this,args).then(function(res){
        try{
          var u=(args[0]&&args[0].url)?args[0].url:String(args[0]||'');
          if(/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(u)){
            if(isProductPage&&/\/cart\/add(\.js)?(?:\?|$)/.test(u)&&res.ok)resetProductSelectionAfterAdd();
            scheduleRefresh();
          }
        }catch(e){}
        return res;
      });
    };
  }

  if(window.XMLHttpRequest){
    var nativeOpen=XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open=function(method,url){
      this.addEventListener('load',function(){
        try{
          if(typeof url==='string'&&/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)){
            if(isProductPage&&/\/cart\/add(\.js)?(?:\?|$)/.test(url)&&this.status>=200&&this.status<300)resetProductSelectionAfterAdd();
            scheduleRefresh();
          }
        }catch(e){}
      });
      return nativeOpen.apply(this,arguments);
    };
  }

  var count=document.getElementById('CartCount')||document.querySelector('.df-cart-count');
  if(count&&window.MutationObserver){
    new MutationObserver(function(){
      var n=parseInt(count.textContent,10);
      if(!isNaN(n)&&n!==lastCartCount){lastCartCount=n;scheduleRefresh();}
    }).observe(count,{childList:true,characterData:true,subtree:true,attributes:true});
  }

  if(window.jQuery){
    window.jQuery(document).on('cart.requestComplete.dfbp ajaxComplete.dfbp',function(_event,xhr,settings){
      try{
        var u=settings&&settings.url?String(settings.url):'';
        if(isProductPage&&/\/cart\/add(\.js)?(?:\?|$)/.test(u)&&xhr&&xhr.status>=200&&xhr.status<300)resetProductSelectionAfterAdd();
      }catch(e){}
      scheduleRefresh();
    });
  }

  if(isWholesale&&typeof window.DestinWholesaleSubtotal==='number'){
    var wholesaleGross=Math.max(0,Number(window.DestinWholesaleSubtotal)||0);
    render(wholesaleGross,estimatedAfterDiscount(wholesaleGross),true);
  }else{
    if(isProductPage)renderProductPreview();
    refreshCart();
  }
})();
